<template>
  <div class="container">
    <b-modal
        :model-value="modEditarMenu"
        :no-close-on-backdrop="true"
        hide-footer
        hide-header-close
        centered
        :title="labels.title"
        header-class="reset-modal-header"
        title-class="reset-modal-title"
        body-class="reset-modal-body"
        class="reset-password-dialog"
    >
        <div v-if="form.idMenu !== null" class="uniform-modal-body">
            <div class="password-policy-box mb-3">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-item">{{ labels.infoText }}</div>
            </div>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.name}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="text" v-model="form.nombre" class="form-control reset-input"> 
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.ruta}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="text" v-model="form.ruta" class="form-control reset-input"> 
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.icono}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-select
                        v-model="form.icono"
                        :options="iconSelectOptions"
                        class="form-control reset-input"
                    />
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.orden}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="text" v-model="form.orden" class="form-control reset-input"> 
                </b-col>
            </b-row>
            <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                <b-button class="reset-btn-primary" @click="guardarMenu">{{ labels.save }}</b-button>
            </div>
        </div>
        <div v-else class="text-center mt-3">
            {{ labels.loading }}
        </div>
    </b-modal>
  </div>
</template>

<script>
import Menu from '../../../services/Menu'; 
import { getMenuIconNames } from '../../../utils/menuIconCatalog';

export default {
    name:"EditarMenu",
    props:['modEditarMenu','infoMenu'],
    data: () => ({
        form: {
            idMenu: null,
            nombre: "",
            ruta: "",
            icono: "",
            orden: ""
        },
        iconOptions: []
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Editar menú",
                    save : "Guardar",
                    close : "Cerrar",
                    name : "Nombre:",
                    ruta : "Ruta:",
                    icono : "Icono:",
                    roles : "Roles:",
                    orden : "Orden:",
                    loading: "Cargando información del menú...",
                    infoTitle: "Datos del menú",
                    infoText: "Actualiza la información y guarda los cambios."
                }
            }else{
                return {
                    title: "Edit menu",
                    save : "Save",
                    close : "Close",
                    name : "Name:",
                    ruta : "Route:",
                    icono : "Icon:",
                    roles : "Role:",
                    orden : "Order:",
                    loading: "Loading menu data...",
                    infoTitle: "Menu information",
                    infoText: "Update the information and save changes."
                }
            }
        },
        iconSelectOptions() {
            const base = this.$store.state._language == "es-ES"
                ? [{ value: "", text: "Seleccione un icono" }]
                : [{ value: "", text: "Select an icon" }];
            const items = this.iconOptions.map((iconName) => ({
                value: iconName,
                text: iconName
            }));
            return [...base, ...items];
        }
    },
    watch: {
        infoMenu: {
            immediate: true,
            handler(newVal) {
                const menu = Array.isArray(newVal) && newVal.length > 0 ? newVal[0] : null;
                if (!menu) {
                    this.form = {
                        idMenu: null,
                        nombre: "",
                        ruta: "",
                        icono: "",
                        orden: ""
                    };
                    return;
                }

                this.form = {
                    idMenu: menu.id,
                    nombre: menu.nombre || "",
                    ruta: menu.ruta || "",
                    icono: menu.icono || "",
                    orden: menu.orden || ""
                };
            }
        }
    },
    mounted(){
        this.iconOptions = getMenuIconNames();
    },
    methods:{
        cierraModal(){
            // console.log("CierraModal") 
            this.$emit('closeModal',false) 
        },
        guardarMenu(){
            // console.log("guardaMenu",this.roles) 
            if(this.form.nombre == ""){ 
                this.$toast.error(`Diligenciar el campo Nombre`) 
            
            }else if(this.form.ruta == ""){ 
                this.$toast.error(`Diligenciar el campo Ruta`) 
            
            }else if(this.form.icono == ""){ 
                this.$toast.error(`Diligenciar el campo Icono`) 

            }else if(this.form.orden == ""){ 
                this.$toast.error(`Diligenciar el campo Orden`) 
            
            }else{
                let formu = {
                    'idMenu' : this.form.idMenu, 
                    'nombre' : this.form.nombre, 
                    'ruta' : this.form.ruta, 
                    'icono' : this.form.icono, 
                    'orden' : this.form.orden, 
                    // 'roles' : this.infoMenu[0].roles, 
                    'idUser' : this.$store.state.userId 
                }
                console.log(formu) 

                Menu.updateMenuById(formu) 
                .then((res) => { 
                    // console.log(res) 
                    if(res.status == 200){ 
                        this.$toast.success(res.data.message) 
                        location.reload(); 
                    
                    }else if(res.status == 204){ 
                        this.$toast.error("El menú ingresado ya existe") 
                    }
                })
                .catch((err) => { 
                    console.log(err) 
                })
            }
        }
    }
}
</script>

<style>

</style>
